import { getDomElementAsNotNullable } from "../../utils/layoutUtils";
export class BackToTopButton {
    constructor() {
        let mybutton = getDomElementAsNotNullable("backToTopButton");
        //window.onscroll = function () { scrollFunction() };
        //function scrollFunction() {
        //    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        //        mybutton.style.display = "block";
        //    } else {
        //        mybutton.style.display = "none";
        //    }
        //}
        // When the user clicks on the button, scroll to the top of the document
        mybutton.onclick = () => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        };
    }
}
